<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Présences planifiées
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :items="selectDates" @change="depthDate" dense filled full-width
                        hide-details="true" item-text="name"
                        item-value="value" return-object solo style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @click:clear="cleared()"
                            @keyup.native.enter="search"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="onexportNbrPresences" block class="custom-btn white--text" color="#03A9F4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-export-outline</v-icon>
                <span>Export (Thalia)</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export rapport</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";

function cellRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.className = "colPlannified";
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "PresencesPlanifiees",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      type: null,
      elapse: null,
      lastHighlitedRow: null,
      loading: false,
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      fullPage: false,
      text: "",
      color: "",
      toObject: [],
      toObjectNoHeader: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        selectionMode: "single",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        className: "htCenter htMiddle",
        manualColumnResize: true,
        hiddenColumns: {
          columns: [13, 17, 18],
          indicators: false
        },
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        colHeaders: [
          "Matricule", "Nom", "Prénom", "Brigade", "Nom Shift", "Date début Shift", "Heure début Shift", "Date pointage Shift",
          "Date fin Shift", "Heure fin Shift", "Date dépointage Shift", "Durée présence", "Statut agent",
          "Plannifiée", "Arrivée tardive", "Départ anticipé", "Nbre de pointages",
          "Signature CDE", "Signature ADS", "Observations", "Origine", "Date de création", "Matricule créateur"
        ],
        columns: [
          {title: "Matricule", width: "150px"},
          {title: "Nom", width: "160px"},
          {title: "Prénom", width: "200px"},
          {title: "Brigade", width: "160px"},
          {title: "Nom Shift", width: "160px"},
          {
            title: "Date début Shift",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "Heure début Shift", width: "180px"},
          {title: "Date pointage Shift", width: "180px"},
          {
            title: "Date fin Shift",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "Heure fin Shift", width: "180px"},
          {title: "Date dépointage Shift", width: "180x"},
          {title: "Durée présence", width: "230px"},
          {title: "Statut agent", width: "180px"},
          {title: "Plannifiée", width: "120px", type: "checkbox"},
          {title: "Arrivée tardive", width: "160px", type: "checkbox"},
          {title: "Départ anticipé", width: "160px", type: "checkbox"},
          {title: "Nbre de pointages", width: "160px"},
          {title: "Signature CDE", width: "130px"},
          {title: "Signature ADS", width: "130px"},
          {title: "Observations", width: "180px"},
          {title: "Origine", width: "100px"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px"}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 0) {
            const cellValue = this.instance.getSourceDataAtCell(row, 13);
            if (cellValue === false) {
              cellProperties.renderer = cellRenderer;
            }
          }

          return cellProperties;
        }
      }
    }
  },
  created() {
    this.depthDate()
  },
  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value
      apiClient
          .get(`${this.$store.getters.user.baseUrl}/reports/presencesreportbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId"), {timeout: 360000})
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                item["shiftName"],
                moment(item["startDate"], 'YYYY-MM-DD').format('DD-MM-YYYY'),
                item["startTime"],
                item["realDTArrival"] !== null ? moment(item["realDTArrival"]).utc().format('DD-MM-YYYY HH:mm:ss') : "",
                moment(item["endDate"], 'YYYY-MM-DD').format('DD-MM-YYYY'),
                item["endTime"],
                item["realDTDeparture"] !== null ? moment(item["realDTDeparture"]).utc().format('DD-MM-YYYY HH:mm:ss') : "",
                item["presenceDuration"],
                item["status"],
                !item["automaticCreation"],
                item["lateArrival"],
                item["earlyDeparture"],
                item["numberTimeTrackings"],
                item["signatureCDE"],
                item["signatureADS"],
                item["presenceObservations"],
                item["typeRecord"],
                item["creationDate"] !== null ? moment(item["creationDate"]).format("DD-MM-YYYY HH:mm:ss") : "",
                item["originUser"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
            this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
          })

          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Présences_prévues") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Présences_prévues.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    onexportNbrPresences() { // On Click Excel download button
      class Counter extends Map {
        constructor(iter, key = null) {
          super();
          this.key = key || (x => x);
          for (let x of iter) {
            this.add(x);
          }
        }

        add(x) {
          x = this.key(x);
          this.set(x, (this.get(x) || 0) + 1);
        }
      }

      let byMat = new Counter(this.toObjectNoHeader, x => x[0]);
      //console.log("byMat", byMat);

      var datasTmp = []

      let i = 0
      for (var [clef, valeur] of byMat) {
        datasTmp.push([
          this.pad(clef, 3),
          "227",
          "P",
          valeur
        ])
        ++i;
      }

      if (datasTmp.length === 0) {
        this.text = "Il n'y a aucune lignes présences disponibles.";
        this.showAlert('warning')
        return;
      }

      var datas = XLSX.utils.json_to_sheet(datasTmp, {origin: 'A1', skipHeader: true})

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Export_nbr_presences") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Export_nbr_presences_Thalia.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    }
  }
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.colPlannified {
  text-align: center;
  background-color: orange !important;
  font-weight: bold !important;
  font-style: normal !important;
}
</style>